import { USER_LOGGED_IN, USER_LOGGED_IN_ERROR, USER_LOGOUT } from '../../actions/user_actions';

export default function(state = null, action){
    switch (action.type){
        case USER_LOGGED_IN:
            let user = action.payload;
            user['token_date'] = new Date().getTime();
            localStorage.setItem('activeUser', JSON.stringify(user));
            return user;
        case USER_LOGGED_IN_ERROR:
            return {username: null};
        case USER_LOGOUT:
            localStorage.clear();
            return null;
        default:
            break;
    }

    const data = localStorage.getItem('activeUser');
    if(data){
        return JSON.parse(data);
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/reducers/User/user_reducer.js